import Vue from "vue";
import App from "./App.vue";
import store from "@/store";
import i18n from "@/i18n";
import setCartSession from "@/set-cart-session";
import BootstrapVue from "bootstrap-vue";
import axios from "axios";
import NProgress from "nprogress";
import router from "@/router";
import Toasted from "vue-toasted";
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";
import Loading from "vue-loading-overlay";
import installApiRetry from "@/api-retry";

// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

import "./fontawesome";
import { loadVeeLocale } from "./validate";

loadVeeLocale(i18n.locale);

import "nprogress/nprogress.css";

Vue.filter("money", function (amount, symbol) {
  return new Intl.NumberFormat(i18n.locale, {
    style: "currency",
    currency: symbol,
  }).format(amount);
});

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://89c47f2520844055a2ef1aa514aebb92@sentry.io/1727603",
    integrations: [
      new Integrations.Vue({ Vue, attachProps: true, logErrors: true }),
      new Sentry.Integrations.Breadcrumbs({
        console: false,
      }),
    ],
  });
}

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(Toasted);
// Init plugin
Vue.use(Loading);

// axios.defaults.baseURL = process.env.VUE_APP_CART_BASE_URL;
axios.defaults.onDownloadProgress = (e) => {
  const percentage = Math.floor(e.loaded * 1.0) / e.total;
  NProgress.set(percentage);
};
axios.interceptors.response.use((response) => {
  NProgress.done(true);
  return response;
});
installApiRetry(axios, { onError: () => NProgress.done(true) });

Vue.prototype.isIframe =
  window.self != window.top || process.env.NODE_ENV == "development";

new Vue({
  store,
  i18n,
  render: (h) => h(App),
  router,
  created: async function () {
    setCartSession(this);
    await this.$store.dispatch("setCart");
  },
}).$mount("#app");
